import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import PageLayout from "../components/PageLayout";
import ActivityPartner from "../components/ActivityPartner";
import Contact from "../components/Contact";
import { Eyebrow, Reveal } from "../components/Reveal";
import { social } from "../content";

export default function ContactPage() {
  return (
    <PageLayout
      seo={{
        title: "Contact & Booking | Collanmore Island Lodge",
        description: "Contact Collanmore Island Lodge to plan your private island stay in Clew Bay near Westport — enquiries for groups of up to 22 guests.",
        path: "/contact/",
      }}
    >
      <section className="pt-28 pb-4 md:pt-36">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <Reveal>
            <Eyebrow>Contact &amp; Booking</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-6 max-w-3xl font-display text-4xl font-medium leading-[1.05] text-navy md:text-6xl" data-testid="page-h1">
              Tell us about your group
            </h1>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-5 max-w-2xl text-sm font-light leading-relaxed text-navy/75 md:text-base">
              Call Ciaran on +353 86 251 8252, message us on WhatsApp, email ciaran@collanmoreislandlodge.com — or send the enquiry form below and we will help you plan your island escape.
            </p>
          </Reveal>
          <Reveal delay={0.24}>
            <div className="mt-7 flex items-center gap-3" data-testid="contact-social">
              <a
                href={social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Collanmore Island Lodge on Instagram"
                data-testid="contact-instagram"
                className="flex h-11 w-11 items-center justify-center border border-navy/20 text-navy/70 transition-all duration-300 hover:border-gold hover:text-gold"
              >
                <Instagram className="h-4 w-4" />
              </a>
              {social.facebook && (
                <a
                  href={social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Collanmore Island Lodge on Facebook"
                  data-testid="contact-facebook"
                  className="flex h-11 w-11 items-center justify-center border border-navy/20 text-navy/70 transition-all duration-300 hover:border-gold hover:text-gold"
                >
                  <Facebook className="h-4 w-4" />
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
      <Contact />
      <ActivityPartner />
    </PageLayout>
  );
}
